import React from "react";
import cx from "clsx";
import styles from "./AuthCard.module.scss";
import Img1 from "./sales_illustration.svg";
import Img2 from "./workplace_illustration.svg";
import Img3 from "./marketing_illustration.svg";
import Button from "../../atoms/Button/Button";

type CardType = "sales" | "workplace" | "marketing";
type Props = {
  type: CardType;
  heading: string;
  subHeading: string;
  showComponent?: boolean;
  onButtonClick?: any;
  url?: string;
  disabled?: boolean;
  component?: React.FC<any>;
  buttonText?: string | React.ReactElement;
};

const getCardImage = (type: CardType) => {
  const imageMap = {
    sales: Img1,
    workplace: Img2,
    marketing: Img3,
  };
  if (Object.keys(imageMap).includes(type)) {
    return imageMap[type];
  }
  return imageMap.marketing;
};

const AuthCard: React.FC<Props> = ({
  type,
  heading,
  subHeading,
  disabled,
  url,
  onButtonClick,
  showComponent,
  component: Comp,
  buttonText = "Login",
}) => {
  return (
    <div className={cx(styles.authCard, styles[type])}>
      <div className={styles.heading}>{heading}</div>
      <div className={styles.subHeading}>{subHeading}</div>
      {!showComponent ? (
        <>
          <img src={getCardImage(type)} className={styles.img} alt={type} />
          <Button
            className={styles.button}
            disabled={disabled}
            onClick={onButtonClick}
          >
            {buttonText}
          </Button>
        </>
      ) : (
        <div className={styles.componentContainer}>
          <Comp type={type} />
        </div>
      )}
    </div>
  );
};

export default AuthCard;
